import React, { useEffect, useRef, useState } from 'react';
// import { teamMemberOptions, teamNodes } from './mock';
import { Person } from 'type/contact';
import type { MemberDetailNode } from 'nicehubs-plus';

// TODO 组件库生成
interface MemberTreeRef {
  data: any;
  height: number;
  addEventListener: any;
  removeEventListener: any;
}

// 该组件作为防腐层，封装 web-component
interface IProps {
  data?: any;
  onNodeClick?: (data: any) => void;
}

const MemberTree: React.FC<IProps> = (props) => {
  const memberTreeRef = useRef<MemberTreeRef>();
  const [height, setHeight] = useState(window.innerHeight - 235);
  const onNodeClick = ({ detail }: { detail: any }) => {
    const { data, isLeaf }: { data: MemberDetailNode; isLeaf: boolean } = detail[0];
    if (!isLeaf) return;
    props.onNodeClick?.({
      ...data,
      displayName: data.memberName,
      name: data.memberName,
      realName: data.memberName,
      realname: data.memberName,
      staffId: data.refId
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 235);
    };

    window.addEventListener('resize', handleResize);
    if (memberTreeRef.current) {
      // 直接在web component实例上设置复杂类型的 props
      memberTreeRef.current.data = props.data;
      // 初始化-监听事件
      memberTreeRef.current?.addEventListener('node-click', onNodeClick);
      // 卸载时-清除监听
      return () => {
        memberTreeRef.current?.removeEventListener('node-click', onNodeClick);
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [props.data]);

  useEffect(() => {
    if (memberTreeRef.current) {
      memberTreeRef.current.height = height ?? 500;
    }
  }, [height]);

  // // 响应 props 变化
  // const onClickDelete = () => {
  //   if (!memberTreeRef.current) return;
  //   memberTreeRef.current.data = {
  //     ...teamMemberOptions[0],
  //     nodes: teamNodes
  //   };
  // };

  return (
    <>
      <div style={{ width: '100%', margin: 'auto' }}>
        {/* <button onClick={onClickDelete}>变更部门</button> */}
        <ce-member-tree theme="client" ref={memberTreeRef} />
      </div>
    </>
  );
};

export default MemberTree;
